import { useSearch } from "@tanstack/react-router";
import { useEffect } from "react";
import useLocales from "src/hooks/useLocales";

import { ConnectAccountParams } from "../ConnectAccount/ConnectAccount";

export default function useSetLinkLang() {
	const { locale }: ConnectAccountParams = useSearch({
		strict: false
	});

	const { onChangeLang, currentLang } = useLocales();

	useEffect(() => {
		if (locale !== currentLang.value) {
			onChangeLang(locale);
		}
	}, [currentLang, locale]);
}
